import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useRef, useState, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import DEFAULT_OPERATIONS from './newsletter.gql';
export var useNewsletter = function useNewsletter() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _mergeOperations = mergeOperations(DEFAULT_OPERATIONS, props.operations),
      subscribeMutation = _mergeOperations.subscribeMutation,
      subscribeOptions = _mergeOperations.subscribeOptions;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      subscribing = _useState2[0],
      setSubscribing = _useState2[1];

  var _useMutation = useMutation(subscribeMutation, {
    fetchPolicy: 'no-cache'
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      subscribeToNewsletter = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      newsLetterError = _useMutation2$.error,
      data = _useMutation2$.data;

  var formApiRef = useRef(null);
  var setFormApi = useCallback(function (api) {
    return formApiRef.current = api;
  }, []);
  var handleSubmit = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubscribing(true);
              _context.prev = 1;
              _context.next = 4;
              return subscribeToNewsletter({
                variables: {
                  email: data.email,
                  first_name: data.name,
                  what_describes_you: data.type
                }
              });

            case 4:
              if (formApiRef.current) {
                formApiRef.current.reset();
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              if (process.env.NODE_ENV !== 'production') {
                console.error(_context.t0);
              }

            case 10:
              setSubscribing(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [subscribeToNewsletter]);
  var errors = useMemo(function () {
    return new Map([['subscribeMutation', newsLetterError]]);
  }, [newsLetterError]);
  var selectOptions = useQuery(subscribeOptions, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });
  return {
    errors: errors,
    handleSubmit: handleSubmit,
    isBusy: subscribing,
    setFormApi: setFormApi,
    newsLetterResponse: data && data.subscriber,
    selectOptions: selectOptions && selectOptions.data
  };
};